module.exports = __webpack_public_path__ + "img/RIREKI_GOLD.d0f4e5c2.png";